<template>
  <div class="page page-single">
    <HeaderSlide />
    <div class="page-container">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首頁</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/' }">相關連結</el-breadcrumb-item>
        <el-breadcrumb-item>{{related_link['title']}}</el-breadcrumb-item>
      </el-breadcrumb>
      <article>
        <div class="page-title">
          {{related_link['title']}}
        </div>
        <section>
          {{related_link['description']}}
        </section>
        <section>
          <p>{{related_link['link_description']}}： <a :href="related_link['url']">{{related_link['url']}}</a></p>
        </section>
      </article>
    </div>
  </div>
</template>

<script>
  import HeaderSlide from '@/components/frontstage/HeaderSlide.vue';
  import api from '@/api/frontstage'

  export default {
    name: 'related_links',
    components: {
      HeaderSlide,
    },
    created () {
        if (typeof this.$route.params.link === 'undefined' || this.$route.params.link === null) {
          this.$message({
              type: 'error',
              message: '未提供相關連結'
          });
          this.$router.push({ path: `/` })
        }

        if (typeof this.related_links[this.$route.params.link] === 'undefined') {
          this.$message({
                type: 'error',
                message: '沒有此相關連結'
          });
          this.$router.push({ path: `/` })
        }

        this.related_link = this.related_links[this.$route.params.link]
    },
    data() {
      return {
          related_links: {
              'luodong': {
                  title: '林務局羅東林區管理處',
                  description: '羅東林區管理處於民國78年7月1日由蘭陽林區管理處合併原文山林區管理處所轄之文山事業區，改組為羅東林區管理處，目前設有林政課、治山課、作業課、育樂課等4個業務單位，以及秘書室、人事室、主計室、政風室等4個幕僚單位。此外，為配合本處廣闊轄區的現場經營管理需要，下設台北、礁溪、太平山、南澳、冬山5個工作站及任務編組織之太平山國家森林遊樂區管理中心。羅東林區管理處是林務局八個林管處位置最北的一個林管處，其行政區域以宜蘭縣為主，另外還包括新北、花蓮二縣的部份林地。在傳統的林業經營上，由北而南一次劃分為文山、宜蘭、羅東、太平山、南澳及和平等六個國有林事業區，連同大溪事業區的部份林地，合計面積約為176,304公頃。',
                  url: 'https://luodong.forest.gov.tw/',
                  link_description: '前往羅東林管處官方網站',
              },
              'forest': {
                  title: '林務局',
                  description: '林務局於民國78年7月由事業機構改制為公務機關，民國88年再由臺灣省改隸屬中央，在此組織改造的過程，林業經營也被賦予更多生態保育的責任，林務局已從過去的採伐林業、育成林業蛻變為生態林業及文化林業。自民國93年1月30日起，更承接農委會林業處森林科及保育科之業務，成為臺灣自然保育的主管機關。現在的林務局秉持永續森林經營、維護自然生態的信念，從環境保護、經濟發展及社會公義三方面，持續不斷推動各項業務，近年來，更致力於營造健康的森林、創造林產價值鏈、打擊非法採伐、強化國有林治理、落實自然保護區域經營管理、促進山村生態經濟等工作。未來林務局施政目標將著重於推動禁伐天然林政策入法、經濟林使用依據國際森林管理規範，以及里山倡議的深化。',
                  url: 'https://www.forest.gov.tw/',
                  link_description: '前往林務局全球資訊網',
              },
              'recreation': {
                  title: '臺灣山林悠遊網',
                  description: '林務局為推展優質生態旅遊，提供國人便利的旅遊資訊及生態知識查詢管道，全新編輯推出台灣山林悠遊網。臺灣山林悠遊網整合了國家森林遊樂區及全國步道系統導覽網站，共包含「國家森林遊樂區」、「全國步道系統」、「旅遊E點通」、「數位森林誌」、「線上放映室」等主題功能，希望提供民眾人文、生態、環境、景觀設施、多媒體及GIS多方面的豐富資訊饗宴。',
                  url: 'https://recreation.forest.gov.tw/',
                  link_description: '前往臺灣山林悠遊網',
              },
              'tps': {
                  title: '太平山國家森林遊樂區',
                  description: '太平山國家森林遊樂區位於台灣東北部的宜蘭縣境內，轄屬於大同鄉，目前由林務局羅東林區管理處負責管理，整個太平山區幅員廣大，面積廣達12,929.52公頃，包括土場、仁澤(鳩之澤)、中間、蘭台、白嶺、上平、太平山、茂興、翠峰湖、大元山、獨立山等據點，其中開放供民眾遊憩區域有土場、仁澤(鳩之澤)、中間、太平山、茂興、翠峰湖等據點。本森林遊樂區林木蓊鬱、群山青翠的景象，區內有溫泉、雲海、雪景、瀑布、湖泊等豐富的景觀資源，以及瀰漫林間、充滿芬多精與陰離子的清新空氣，是民眾走向自然、從事森林育樂與戶外活動的最好場域。 ',
                  url: 'https://tps.forest.gov.tw/TPSWeb/wSite/mp?mp=1',
                  link_description: '前往太平山國家森林遊樂區入口網',
              },
              'luodong-nec-forestry': {
                  title: '羅東林業文化園區',
                  description: '羅東林業文化園區原為羅東出張所，為太平山林場之製材作業、貯木場、營林辦公廳與職員宿舍，園區內完整保存林業設施、聚落、貯木作業設施、載運機具等，為太平山林業發展之活歷史。民國71年林業政策轉型，太平山伐木終止，隨著都市發展於83-90年間羅東鎮都市計畫第三次通盤檢討，將羅東林場劃定為「林業文化專用區」，93年林務局規劃為「羅東林業文化園區」，98年正式開放一般大眾參觀。93年開始經宜蘭縣政府文化局陸續將辦公廳、處長宿舍、勞工俱樂部、舊檢車庫、職員宿舍、碉堡與貯木池之歷史建築指定登錄為歷史建築，並於101年將整個園區指定登錄為文化景觀區。',
                  url: 'https://www.facebook.com/lfcgexhibition/',
                  link_description: '前往羅東林業文化園區網站',
              },
          },
          related_link: {}
      }
    }
  }
</script>